/**
 * Shared "Sponsored Spiritual Tools" widget — appears on Tarot Card Detail pages,
 * at the bottom of the Tarot Gallery, and after a 5-Card Reading.
 * Each click is tracked via /api/sponsored-links/click/{id}.
 */
import React, { useEffect, useState } from 'react';
import api from '../utils/api';

const SponsoredTools = ({ context = 'general', maxItems = 8 }) => {
  const [links, setLinks] = useState([]);

  useEffect(() => {
    api.get('/sponsored-links/public')
      .then(r => setLinks((r.data.links || []).slice(0, maxItems)))
      .catch(() => {});
  }, [maxItems]);

  if (!links.length) return null;

  const click = (id) => { api.post(`/sponsored-links/click/${id}`).catch(() => {}); };

  return (
    <section className="mt-10 pt-6 border-t border-slate-800" data-testid={`sponsored-tools-${context}`}>
      <div className="flex items-center justify-between mb-3">
        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-amber-400/70">Sponsored</div>
          <h3 className="text-lg font-bold text-amber-200">Spiritual Tools for Your Journey</h3>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {links.map(l => (
          <a
            key={l.id}
            href={l.url}
            target="_blank"
            rel="nofollow sponsored noopener"
            onClick={() => click(l.id)}
            data-testid={`sponsored-link-${l.id}`}
            className="block rounded-xl overflow-hidden border border-slate-800 bg-slate-900 hover:border-amber-400 group"
          >
            {l.image_url && (
              <div className="aspect-square bg-slate-950 overflow-hidden">
                <img src={l.image_url} alt={l.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition" />
              </div>
            )}
            <div className="p-2.5">
              {l.category && <div className="text-[10px] text-amber-400 uppercase">{l.category}</div>}
              <div className="text-sm font-bold text-amber-200 line-clamp-1">{l.title}</div>
              {l.subtitle && <div className="text-[11px] text-slate-400 line-clamp-2 mt-0.5">{l.subtitle}</div>}
              <div className="mt-2 text-xs font-bold text-black bg-amber-500 inline-block px-2.5 py-1 rounded-md">{l.cta_text || 'Shop Now'} →</div>
            </div>
          </a>
        ))}
      </div>
      <div className="mt-3 text-[10px] text-slate-500 text-center">Sponsored · Anant Web Portal earns a small commission on purchases (helps us keep readings free).</div>
    </section>
  );
};

export default SponsoredTools;
